import { FC } from 'react';
import { Anchor, Box, Group, SimpleGrid, Text, rem } from '@mantine/core';
import { TbFileUpload, TbPhoto, TbX, TbTrash } from 'react-icons/tb';
import { Dropzone, DropzoneProps, IMAGE_MIME_TYPE } from '@mantine/dropzone';
import { FormAnswerMap } from '../productTypeForm/ProductTypeForm';
import { UUID } from 'crypto';
import classNames from 'classnames';
import styles from './AppDropzone.module.scss';

const MAX_FILESIZE_IN_MB = 30;

interface Props extends Omit<DropzoneProps, 'onDrop'> {
	formAnswer: FormAnswerMap;
	handleChange: (files: File[]) => void;
	handleFileRemove: (attachmentId: UUID) => void;
	isErorr: boolean;
}

export const AppDropzone: FC<Props> = ({
	formAnswer,
	handleChange,
	handleFileRemove,
	isErorr,
	...props
}) => {
	return (
		<Box
			className={classNames(styles.box, {
				[styles.boxError]: false,
			})}
			p="sm"
			mb="sm"
		>
			<Dropzone
				maxSize={MAX_FILESIZE_IN_MB * 1024 ** 2}
				accept={IMAGE_MIME_TYPE}
				{...props}
				onDrop={(files) => {
					handleChange(files);
				}}
			>
				<Group
					justify="center"
					gap="xl"
					mih={150}
					style={{ pointerEvents: 'none' }}
				>
					<Box>
						<Dropzone.Accept>
							<TbFileUpload
								style={{
									width: rem(52),
									height: rem(52),
									color: 'var(--mantine-color-blue-6)',
								}}
							/>
						</Dropzone.Accept>
						<Dropzone.Reject>
							<TbX
								style={{
									width: rem(52),
									height: rem(52),
									color: 'var(--mantine-color-red-6)',
								}}
							/>
						</Dropzone.Reject>
						<Dropzone.Idle>
							<TbPhoto
								style={{
									width: rem(52),
									height: rem(52),
									color: 'var(--mantine-color-dimmed)',
								}}
							/>
						</Dropzone.Idle>
					</Box>

					<Box>
						<Text size="xl" inline mb="sm">
							Przeciągnij pliki lub kliknij, aby dodać
						</Text>
						<Text size="sm" c="dimmed" inline>
							Dodaj dowolną liczbę plików, każdy plik nie powinien przekraczać{' '}
							{MAX_FILESIZE_IN_MB}MB
						</Text>
					</Box>
				</Group>
			</Dropzone>
			<SimpleGrid cols={3} spacing="sm">
				{formAnswer.attachments.map((attachment, idx) => (
					<Box key={idx} bg="gray.3" p="sm">
						<Text size="md" truncate="end">
							{attachment.name}
						</Text>
						<Anchor
							c="red"
							lh={0}
							onClick={(e) => {
								e.preventDefault();
								e.stopPropagation();
								handleFileRemove(attachment.id);
							}}
						>
							<TbTrash />
						</Anchor>
					</Box>
				))}
			</SimpleGrid>
		</Box>
	);
};
